<template>
  <div>
    <div v-if="booking">
      
      <BookingSummary 
        :booking="booking" 
        :bondingTypes="bondingTypes" 
        :customerNote="customerNotes" 
        :bookingChangeReasons ="bookingChangeReasons"
        @handleBooking="handleUpdateBooking" />
      
      <!-- <button class="button mt-1" v-on:click="handleUpdateBooking()" v-if="(booking.customer_id !==null || booking.agent_id !==null ) && userRole == 1">
        <span>Update booking</span>
      </button> -->

      <!-- Booking Passengers Start-->
      <BookingPassengers :passengers="booking.passengers" 
                    @update-passenger-list="updatePassenger" 
                    @handleBooking="getBooking"/>
      <!-- Booking Passengers End-->

      <!-- Booking Tours Start -->
      <BookingItems 
                :booking="booking"
                :tour_bookings="booking.tour_bookings" 
                :tours-total-price="toursTotalPrice" 
                :passengers="booking.passengers" 
                :multiple-bookables="multipleBookables" 
                processType="edit"
                @updateBookingHistory="updateBookingHistory"
                @handleBooking="getBooking"/>
      <!-- Booking Tours End -->

      <div class="box">
        <div class="wrap row w-100">
          <div class="col-3">
            <label for="custom_airline_ref_email" class="fw-bold">Custom airline reference email</label><br>
            <label class="switch mt-1">
              <input id="custom_airline_ref_email" type="checkbox" v-model="customAirlineRefEmail" />
              <span class="switch__slider"></span>
            </label>
          </div>

          <template v-if="customAirlineRefEmail">
            <div class="col-3">
              <label class="fw-bold">Allowed domain</label><br>
              <v-select v-model="booking.allowed_domain" :options="['mehmail.co.uk']" @change="bindAirlineRefEmail"></v-select>
            </div>

            <div class="col-3">
              <label class="fw-bold">Airline reference email</label><br>
              <input class="form-control" type="text" v-model="booking.airline_reference_email">
            </div>
            <div class="col-3">
              <button class="button mt-3" @click="updateAirlineReferenceEmail">
                <span>Update</span>
              </button>
            </div>
          </template>
        </div>
      </div>

      <!-- <button class="mt-1 button" v-on:click="selectingTours = true" v-if="userRole == 1">Add tour to booking</button>
      <div class="modal" v-if="selectingTours == true">
        <BookingTourSelect :booking="booking" 
                    @updateBookingHistory="updateBookingHistory"/>
        <button type="button" class="icon icon--unlink" v-on:click="selectingTours = false">Close</button>
      </div>
      <div class="modal__bg" v-if="selectingTours == true"></div> -->

      <template v-if="booking.old_tour_booking !== null">
        <h2>Imported Travelink data</h2>
        <div class="box">
          <div class="wrap">

            <dl style="max-width: 600px;">
              <dt>Lead passenger name</dt>
              <dd>{{ booking.old_lead_passenger }}</dd>
              <dt>Tour</dt>
              <dd>{{ booking.old_tour_booking.old_tour }}</dd>
              <dt>Room</dt>
              <dd>{{ booking.old_tour_booking.old_room }}</dd>
              <dt>Date</dt>
              <dd>{{ booking.old_tour_booking.old_departure_date }}</dd>
              <dt>Price</dt>
              <dd>{{ booking.old_tour_booking.old_total_revenue | formatCurrency  }}</dd>
            </dl>

            <template v-if="booking.tour_bookings.length == 0">
              <br>
              <button class="button" v-on:click="selectingTours = true">Relink tour to booking</button>
              <div class="modal" v-if="selectingTours == true">
                <BookingTourSelect :booking="booking"></BookingTourSelect>
                <button type="button" class="icon icon--unlink" v-on:click="selectingTours = false">Close</button>
              </div>
              <div class="modal__bg" v-if="selectingTours == true"></div>
            </template>

          </div>
        </div>
      </template>

      <!-- Additional Documents Start -->
      <AdditionalDocuments :booking="booking"/>
      <!-- Additional Documents  End -->
      
      <!-- Specail Requests Start -->
      <SpecialRequest :booking="booking"/>
      <!-- Specail Requests End -->
      
      <!-- Booking Extras Start -->
      <BookingExtras :booking="booking" 
                      :bookingExtras="booking.extras" 
                      :extras-total-price="extrasTotalPrice"
                      @handleBooking="getBooking"  />
      <!-- Booking Extras End -->
      
      <!-- Booking Discounts Start -->
      <BookingDiscounts :bookingDiscounts="bookingDiscounts" 
                        :discounts-total-price="discountsTotalPrice"  
                        :booking="booking" 
                        v-on:update-booking="updateBooking" 
                        :tours-total-price="toursTotalPrice" 
                        :tours-base-price="toursBasePrice"  
                        :tourIds="tourIds" 
                        @handleBooking="getBooking"/>
      <!-- Booking Discounts End -->

      <template v-if="booking.agent_id == null">
        <!-- Booking Accounts Section -->
        <BookingAccounts :booking="booking" :totalDue="totalDue" v-on:update-booking="updateBooking"></BookingAccounts>
        <!-- End Booking Accounts Section -->
      </template>

      <template v-else>
        <!-- Booking Accounts Section -->
        <BookingAgentAccounts :booking="booking" :totalDue="totalDue" v-on:update-booking="updateBooking"></BookingAgentAccounts>
        <!-- End Booking Accounts Section -->
      </template>

      <BookingPayment :bookingID="booking.id" v-on:get-booking="getBooking"></BookingPayment>

      <BookingReceipts :booking="booking"></BookingReceipts>

      <!-- Booking Documents Start -->
      <BookingDocuments :bookingID="booking.id" 
                        :bookingDetails="booking"
                        :bookingDocumentRecords="bookingDocumentRecords" 
                        :balanceDue="booking.balance" 
                        :bookingForDetails="{agent:booking.agent_id, customer:booking.customer_id}" 
                        :bookingPassengers="booking.passengers"
                        :emailTemplates = "emailTemplates"
                        v-on:get-booking="getBooking" 
                        :bookingChangeReasons ="bookingChangeReasons"
                        @updateBookingHistory="updateBookingHistory"/>
      <!-- Booking Documents End -->

      <!-- Booking History Start -->
      <BookingHistory :bookingID="booking.id" ref="bookingHistoryRef"/>
      <!-- Booking History End -->

    </div>
  </div>
</template>

<script>
import BookingSummary from '@/components/BookingSummary.vue'
import BookingItems from '@/components/BookingItems.vue'
import BookingPassengers from '@/components/BookingPassengers.vue'
import BookingTourSelect from '@/components/BookingTourSelect.vue'
import BookingAccounts from '@/components/BookingAccounts.vue'
import BookingAgentAccounts from '@/components/BookingAgentAccounts.vue'
import BookingDocuments from '@/components/BookingDocuments.vue'
import BookingExtras from '@/components/BookingExtras.vue'
import BookingDiscounts from '@/components/BookingDiscounts.vue'
import BookingPayment from '@/components/BookingPayment.vue'
import BookingReceipts from '@/components/BookingReceipts.vue'
import BookingHistory from '@/components/BookingHistory.vue'
import AdditionalDocuments from '../components/BookingEdit/AdditionalDocuments.vue'
import SpecialRequest from '../components/BookingEdit/SpecialRequest.vue'

import {mapGetters} from 'vuex'

  export default {
    name: 'BookingEdit',
    components: {
      BookingSummary,
      BookingItems,
      BookingPassengers,
      BookingTourSelect,
      BookingDocuments,
      BookingAccounts,
      BookingAgentAccounts,
      BookingPayment,
      BookingExtras,
      BookingDiscounts,
      BookingReceipts,
      BookingHistory,
      AdditionalDocuments,
      SpecialRequest
    },
    data () {
      return {
        booking: null,
        newTourOptions: [],
        selectingTours: false,
        customAirlineRefEmail: false,
        showCustomAirlineSwitch: true,
        emailTemplates:[],
        bondingTypes:[],
        updateBookClick:false,
        update_intimate_customer:false,
        bookingTours: [],
        bookingChangeReasons: [],
        selectedBookingChangeReasons: []
      }
    },
    computed: {
      ...mapGetters(['getLoadStatus','getBookingAcceptedStatus']),
      userRole() {
        let user_role = localStorage.getItem("user_role");
        if (user_role == 1) {
          // this.showPassenger = true
        }
        return user_role
      },
      toursTotalPrice: function() {
        let total = 0
        if(this.booking.tour_bookings.length > 0) {
          for(const tour_booking of this.booking.tour_bookings) {
            if(tour_booking.sale_price) {
              total += (tour_booking.sale_price * tour_booking.guests)
            } else {
              total += (tour_booking.price * tour_booking.guests)
            }
          }
        }
        return total
      },
      toursBasePrice: function() {
        let total = 0
        if(this.booking.tour_bookings.length > 0) {
          for(const tour_booking of this.booking.tour_bookings) {
            if(tour_booking.sale_price) {
              total += (tour_booking.sale_price * tour_booking.guests)
            } else {
              if (tour_booking.base_price) {
                total += (tour_booking.base_price * tour_booking.guests)
              } else {
                total += (tour_booking.price * tour_booking.guests)
              }
            }
          }
        }
        return total
      },
      extrasTotalPrice: function() {
        let total = 0
        if(this.booking.extras.length > 0) {
          for(const option of this.booking.extras) {
            total += (option.price * option.pivot.qty)
          }
        }
        return total
      },
      discountsTotalPrice: function() {
        let total = 0
        if(this.booking.discounts.length > 0) {
          for (const option of this.booking.discounts) {
            let penalty_type = option.penalty_type
            let on_base_price = option.on_base_price
            let discount_value = option.value
            let manual_discount_amount = Number(option.pivot.manual_discount_price);

            if (option.pivot.discount_content) {
              let discount_content = JSON.parse(option.pivot.discount_content)
                penalty_type = discount_content['penalty_type']
                on_base_price = discount_content['on_base_price']
                discount_value = discount_content['value']
            }

            if (manual_discount_amount > 0 ) {
              total+=manual_discount_amount
            }else if (penalty_type == 0) {
              total += (discount_value * option.pivot.qty)
            } else {
              if (on_base_price == 0) {
                total += ((discount_value * this.toursTotalPrice) / 100)
              } else {
                total += ((discount_value * this.toursBasePrice) / 100)
              }
            }
          }
        }

        return total
      },
      bookingDiscounts: function (){
        let booking_discount = []

        if (this.booking.discounts.length > 0) {
            for(const discount of this.booking.discounts) {
                if (discount.pivot.discount_content) {
                  let discount_content = JSON.parse(discount.pivot.discount_content)
                    discount_content['booking_discount_attached_id'] = discount.pivot.id
                    discount_content['qty'] = discount.pivot.qty
                    discount_content['manual_discount_price'] = discount.pivot.manual_discount_price
                    booking_discount.push(discount_content)
                } else {
                  let discount_content = {
                        'booking_discount_attached_id' :  discount.pivot.id,
                        'qty': discount.pivot.qty,
                        'discount_id': discount.id,
                        'tour_id': discount.tour_id,
                        'code': discount.code,
                        'description': discount.description,
                        'value': discount.value,
                        'penalty_type': discount.penalty_type,
                        'per_person': discount.per_person,
                        'on_base_price': discount.on_base_price,
                        'manual_discount_price' : discount.pivot.manual_discount_price
                    }
                    booking_discount.push(discount_content)
                }
            }
        }

        return booking_discount
      },

      bookingDocumentRecords: function (){
        let booking_document_records = []
        if (this.booking.documents.length > 0) {
          booking_document_records = this.booking.documents
        }
        return booking_document_records
      },
      // @TODO: This needs to intelligently account for if there is an old booking... don't want to mess with price of imported bookings
      totalDue: function() {
        return this.toursTotalPrice + this.extrasTotalPrice - this.discountsTotalPrice
      },
      customerName() {
        return (this.booking.customer ? this.booking.customer.first_name + ' ' + this.booking.customer.last_name : this.booking.old_customer.first_name + ' ' + this.booking.old_customer.last_name)
      },
      multipleBookables() {
        if(this.booking.tour_bookings.length > 1) {
          return true
        } else {
          return false
        }
      },
      tourIds: function() {
        if(this.booking.tour_bookings.length) {
          var ids = [];
          for (let tour of this.booking.tour_bookings) {
            ids.push(tour.tour_id)
          }
          return ids
        }
        return null
      }
    },
    created () {
      this.getBooking()
      this.userRole
    },
    watch: {
      '$route': 'getBooking'
    },
    methods: {
      getBooking () {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'bookings/' + this.$route.params.id, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
          .then(response =>
          {
            this.$store.dispatch('setLoadStatus')
            this.booking = response.data.booking[0]

            if (this.booking.changes_accepted == 0 ) {
              this.$store.dispatch('setChangeAcceptedStatus')
            }

            if(this.booking.customer_id == null) {
              if(this.booking.old_customer_id !== null) {
                this.booking.customer = this.booking.old_customer;
              }
            }

            if(this.booking.agent_id == null) {
              if(this.booking.old_agent_id !== null) {
                this.booking.agent = this.booking.old_agent;
              }
            }

            if(this.booking.affiliate_id == null) {
              if(this.booking.old_affiliate_id !== null) {
                this.booking.affiliate = this.booking.old_affiliate;
              }
            }

            if(this.booking.airline_reference_email) {
              this.customAirlineRefEmail = true;
            }else {
              this.customAirlineRefEmail = false;
            }

            this.booking.passengers = this.booking.passengers.concat(this.booking.old_passengers)
            this.bookingTours = this.booking.tour_bookings

            if (response.data.emailTemplates) {
              this.emailTemplates = response.data.emailTemplates
            }
            if ('booking_change_reasons' in response.data) {
              this.bookingChangeReasons = response.data.booking_change_reasons
            }
            if ('bondingTypes' in response.data) {
              this.bondingTypes = response.data.bondingTypes
            }

            this.booking.tour_bookings = this.booking.tour_bookings.map((tour_booking) => {
              let airlineCosting = []
              if (!('airline_cost' in tour_booking)) {
                airlineCosting = [
                  {
                    id: this.getRandomInt(1, 1000),
                    airline_ref:null,
                    flight_cost:null,
                    booked_date:null,
                    airline_invoice: null,
                    selectedFile: null
                  }
                ]
              } else {
                airlineCosting = tour_booking.airline_cost.map((airlineCost) => {
                  return {
                    ...airlineCost,
                    selectedFile: null
                  }
                })
              }
              return {
                ...tour_booking,
                airline_cost: airlineCosting
              }
            })
          })
      },
      getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      updateBooking () {
        if(this.booking.tour_bookings.length < 1) {
          this.$notify({
            type: 'error',
            title: 'Tour not selected'
          });
          return false;
        }
        let departure_date = this.booking.tour_bookings[0].instance.departure_date;
        for (let i = 1, len=this.booking.tour_bookings.length; i < len; i++) {
          let v = this.booking.tour_bookings[i].instance.departure_date;
          departure_date = (v < departure_date) ? v : departure_date;
        }

        var tourBookingRequest = []
        for (let item of this.booking.tour_bookings) {
          if(!this.validateRoomRequired(item)) {
            this.$dialog.alert('The number of guests you provided does not match the required room count', {html: true, okText: 'Close'});
            return false;
          }

          var tour_booking = {
            id: item.id,
            tour_id: item.tour.id,
            tour_instance_id: item.tour_instance_id,
            tour_room_id: item.tour_room_id,
            rooms: item.rooms,
            guests: item.guests,
            price: item.price,
            base_price: item.base_price,
            supplement_price: item.supplement_price,
            cost: item.cost,
            airline_ref: item.airline_ref,
            passengers: item.passengers,
            special_requests: item.special_requests,
            airline_ref_added_at: item.airline_ref_added_at,
            airline_flight_cost: item.airline_flight_cost,
          }
          tourBookingRequest.push(tour_booking)
          // console.log(tourBookingRequest)
        }

        var bookingRequest = {
          customer_id: this.booking.customer ? this.booking.customer.id : null,
          agent_id: this.booking.agent ? this.booking.agent.id : null,
          affiliate_id: this.booking.affiliate ? this.booking.affiliate.id : null,
          passengers: this.booking.passengers,
          extras: this.booking.extras,
          discounts: this.booking.discounts,
          balance_due: this.booking.balance_due,
          booking_ref: this.booking.booking_ref,
          tour_bookings: tourBookingRequest,
          special_request: this.booking.special_request,
          departure_date: departure_date,
          airline_reference_email: this.booking.airline_reference_email,
          deposit_due : this.booking.deposit_due,
          agent_comission_percent:this.booking.agent_comission_percent,
          bonding_type:this.booking.bonding_type,
          intimate_customer:(this.update_intimate_customer) ? 'yes' : 'no',
          intimate_customer_reasons:this.selectedBookingChangeReasons,
          cancellation_charge:this.booking.cancellation_charge
        }

        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'bookings/' + this.$route.params.id, {
          method: 'POST',
          body: JSON.stringify(bookingRequest),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success) {

            this.updateBookClick = false
            this.getBooking()
            this.$notify({
              type: 'success',
              title: response.message
            });

          } else if (response.errors) {

            this.$notify({
              type: 'error',
              title: response.message
            });
            
          }
          this.update_intimate_customer = false
          this.$store.dispatch('setLoadStatus')
        });
      },
      bindAirlineRefEmail() {
        if(this.booking.allowed_domain) {
          this.booking.airline_reference_email = `${this.booking.customer.first_name.toLowerCase()}.${this.booking.customer.last_name.toLowerCase()}@${this.booking.allowed_domain}`
        } else {
          this.booking.airline_reference_email = null;
        }
      },
      validateRoomRequired(tour_bookings) {
        const roomRequired = Math.ceil( tour_bookings.guests / tour_bookings.room.occupancy );
        if(roomRequired !== parseInt(tour_bookings.rooms)) {
          return false;
        }else {
          return true;
        }
      },
      handleUpdateBooking(customerIntimation=false, booking_intimation_reasons=[]){
        this.update_intimate_customer = customerIntimation
        this.selectedBookingChangeReasons = booking_intimation_reasons
        this.updateBooking()
      },
      updatePassenger(passenger_list) {
        this.booking.passengers = passenger_list
      },
      updateBookingHistory() {
        this.$refs.bookingHistoryRef.doSearch()
      },
      updateAirlineReferenceEmail() {
        this.$store.dispatch('setLoadStatus')
        fetch(`${this.$api}update-booking/${this.$route.params.id}/update-booking-custom-airline` , {
          method: 'POST',
          body: JSON.stringify({
            allowed_domain : this.booking.allowed_domain,
            airline_reference_email : this.booking.airline_reference_email
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
          .then(response =>
          {
            this.$store.dispatch('setLoadStatus')
            this.$notify({
              type: 'success',
              title: response.message
            });
          })
      }
    },
  beforeDestroy() {
      if (this.getBookingAcceptedStatus) {
        this.$store.dispatch('setChangeAcceptedStatus')  
      }
    }
  }
</script>
